export const LoginToasterMessage = {
  loginFailedMessage: (): string => `Something went wrong. Please try again later`,
  roleFailedMessage: (): string =>
    `It seems there is an issue with your role. Please contact the admin for assistance.`,
};
